import { formatEuro } from '../lib/catalog'

// Prices are normal weight and muted on the parchment ground — the kiosk's treatment.
// Tabular numerals so the right-aligned columns line up digit for digit.
//
// `from`: the dish can cost more than this (a paid option, catalog.ts `isFromPrice`).
// The word is chrome copy like "deposit" and gets the deposit's treatment — small,
// lighter, on the number's baseline — so the number itself never changes (owner's
// choice 2026-11-05, render A of four).
/** The secondary size next to a price — "from" and "+ 0,15 deposit" share it (build-guide §4). */
export const SECONDARY_SIZE = 22

export function Price({ cents, size, from = false }: { cents: number; size: number; from?: boolean }) {
  return (
    <span
      className="font-secondary font-normal text-gray-600 tabular-nums whitespace-nowrap"
      style={{ fontSize: size, lineHeight: 1 }}
    >
      {from ? (
        <span className="text-gray-400 mr-[10px]" style={{ fontSize: SECONDARY_SIZE }}>
          from
        </span>
      ) : null}
      {formatEuro(cents)}
    </span>
  )
}

/** Statiegeld is charged on top of the price and is never folded into it. */
export function Deposit({ cents, size = SECONDARY_SIZE, inline = true }: { cents: number; size?: number; inline?: boolean }) {
  if (!cents) return null
  return (
    <span
      className={'font-secondary font-normal text-gray-400' + (inline ? ' ml-[10px]' : '')}
      style={{ fontSize: size, lineHeight: 1 }}
    >
      {'+ ' + formatEuro(cents) + ' deposit'}
    </span>
  )
}
